export default __webpack_public_path__ + "static/media/account_04.15dc793d.png";